module.exports = __webpack_public_path__ + "img/colosseumtraining-h-474x356.a0098da8.jpg";